import checkAuthenticated from "@/router/middlewares/checkAuthenticated";

export default [
    {
        path: '/payments',
        name: 'PaymentsView',
        component: () => import(/* webpackChunkName: "payments" */ '../modules/invoices/payments/PaymentsView'),
        meta: {
            moduleId: 'payments',
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/smartcontrolling',
        name: 'SmartControllingView',
        component: () => import(/* webpackChunkName: "smart-controlling" */ '../../src/modules/invoices/smart_controlling/SmartControllingView'),
        meta: {
            moduleId: 'smartcontrolling',
        },
        beforeEnter: checkAuthenticated
    },
]
